/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".my-12[_ngcontent-%COMP%] {\n  margin: 12% 0; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/login/login.component.scss.shim.ngstyle.js.pre-build-optimizer.js